// import './ModelViewer.css';

// const Home = () => {
// 	return (
// 		<main className="Home">
// 			<div className="Home__Container">
// 				<div className="Home__Subtitle TextShadow">AUSTRALIAN WILDLIFE</div>
// 				<div className="Home__Title TextShadow">FINE ART DRAWINGS</div>
// 				<div className="Home__Subtitle TextShadow"></div>
// 				<div className="Home__Title TextShadow"></div>

// 				<div className="Home__ButtonContainer">
// 					<Button link="/greetingcards" label="VIEW PRODUCTS"></Button>
// 				</div>
// 			</div>
// 		</main>
// 	);
// };

import { useState, useRef, Suspense } from 'react';
import { Canvas, extend, useFrame, useLoader } from '@react-three/fiber';
import { useGLTF, Effects, OrbitControls, Stars } from '@react-three/drei';
import { UnrealBloomPass } from 'three-stdlib';
import { useControls } from 'leva';
import {
    EffectComposer,
    N8AO,
    Bloom,
    Noise,
    Vignette,
} from '@react-three/postprocessing';

import PlatformEdgeGlow from './PlatformEdgeGlow';
import Platform from './Platform';
import GR130 from './GR130';

extend({ UnrealBloomPass });

const Home = () => {
    // const { intensity, radius, red, green, blue } = useControls({
    //     intensity: { value: 1.2, min: 0, max: 5, step: 0.01 },
    //     radius: { value: 1, min: 0, max: 1, step: 0.01 },
    //     red: { value: 0, min: 0, max: 50, step: 0.01 },
    //     green: { value: 30, min: 0, max: 50, step: 0.01 },
    //     blue: { value: 1, min: 0, max: 50, step: 0.01 },
    // });

    const intensity = 0.2;
    const radius = 1;
    const red = 50;
    const blue = 0;
    const green = 10;

    return (
        <Canvas
            style={{
                paddingTop: '64px',
                paddingBottom: '64px',
                height: '100vh',
                width: '100vw',
            }}
            dpr={[1, 2]}
            orthographic
            camera={{ zoom: 20, position: [8, 6, 15] }}
        >
            <OrbitControls
                enableZoom={true}
                enablePan={false}
                rotateSpeed={1}
                // autoRotate={true}
                autoRotateSpeed={1}
                maxPolarAngle={0.4 * Math.PI}
                preserveDrawingBuffer={true}
                alpha={true}
            />

            <color
                attach='background'
                args={['#23252a']}
            />
            {/* <fog attach="fog" args={['#22292f', 0, 30]} /> */}

            <directionalLight
                position={[0, 2, 20]}
                target-position={[0, 0, 0]}
                intensity={0.7}
                color={'#fff'}
                castShadow={true}
            />
            <directionalLight
                position={[-20, 2, 0]}
                target-position={[0, 0, 0]}
                intensity={0.7}
                color={'#fff'}
                castShadow={true}
            />
            <ambientLight
                intensity={0.2}
                color={'#fff'}
            />

            <Effects disableGamma>
                {/* threshhold has to be 1, so nothing at all gets bloom by default */}
                <unrealBloomPass
                    threshold={1}
                    strength={intensity}
                    radius={radius}
                />
            </Effects>
            <Suspense fallback={null}>
                {/* <Shape> */}

                {/* </Shape> */}
                <PlatformEdgeGlow
                    position={[0, -5, 0]}
                    color={[red, green, blue]}
                />
                <Platform
                    position={[0, -5, 0]}
                    color={[1, 1, 1]}
                />

                <GR130
                    position={[0, 3, 0]}
                    color={[1, 1, 1]}
                />
            </Suspense>
        </Canvas>
    );
};

// function Shape({ children, color, ...props }) {
// 	const [hovered, hover] = useState(true);
// 	return (
// 		<mesh
// 			{...props}
// 			onPointerOver={() => hover(false)}
// 			onPointerOut={() => hover(true)}
// 		>
// 			{children}
// 			{/* Now, in order to get selective bloom we simply crank colors out of
// 		  their natural spectrum. Where colors are normally defined between 0 - 1 we push them
// 		  way out of range, into a higher defintion (HDR). What previously was [1, 1, 1] now could
// 		  for instance be [10, 10, 10]. This requires that toneMapping is off, or it clamps to 1 */}
// 			<meshBasicMaterial color={hovered ? color : 'white'} toneMapped={false} />
// 		</mesh>
// 	);
// }

export default Home;
